import React, { useRef, useState } from 'react';
import ConsentFormsNavbar from '../../../components/common/ConsentFormsNavbar';
import ProfileBar from './ProfileBar';
import { Button, Modal, Container, Card, Form, Row, Col, Table } from 'react-bootstrap';
import { useLocation, useNavigate, useParams } from 'react-router';
import moment from 'moment';
import classNames from 'classnames';
import LdcApi from '../../../LdcApis';
import { useToasts } from 'react-toast-notifications';
import CanvasDraw from 'react-canvas-draw';
import { useEffect } from 'react';

const MethotrexateMessage = () => {
  // let appointmentData = JSON.parse(localStorage.getItem('appointmentData'));
  const location = useLocation();

  const appointmentId = useParams();

  const [mouseDisable, setMouseDisable] = useState('auto');
  const [patientSignature, setPatientSignature] = useState('');
  const [brushColor, setBrushColor] = React.useState('#000');
  const [btnSubmit, setBtnSubmit] = useState(false);
  const navigate = useNavigate();
  // const hideForms = () => {
  //   navigate('/confirmation');
  // };

  const [formData, setFromData] = useState({
    doctorInitiating: location?.state?.[0]?.doctorName,
    patientName: location?.state?.[0]?.patientName,
    date: moment(new Date()).format('DD/MM/YYYY')
  });

  const [validationError, setValidationError] = useState({
    patientName: false,
    date: false,
    patientSignature: false,
    doctorInitiating: false
  });

  const sigPatientCanvas = useRef();

  const handelOnchangeValue = (e) => {
    setFromData({ ...formData, [e.target.name]: e.target.value });
  };

  const { addToast } = useToasts();

  useEffect(() => {
    document.title = 'Methotrexate Consent Form - LDC';
    localStorage.setItem('confirmationCode', true);
  }, []);

  // signature  start************************************************
  const canvasRef = useRef(null);

  const defaultProps = {
    loadTimeOffset: 5,
    lazyRadius: 0,
    brushRadius: 2,
    catenaryColor: '#0a0302',
    gridColor: 'rgba(150,150,150,0.17)',
    hideGrid: true,
    canvasHeight: 300,
    disabled: false,
    imgSrc: '',
    saveData: '',
    immediateLoading: false,
    hideInterface: false
  };

  const getImgPatientSignature = () => canvasRef.current.canvasContainer.children[1].toDataURL();

  const patientSignatureCanvasChange = () => {
    const saveData = getImgPatientSignature();
    setPatientSignature(saveData);
    if (patientSignature == '') {
      setValidationError({ ...validationError, patientSignature: true });
    } else {
      setValidationError({ ...validationError, patientSignature: false });
    }
  };

  const patientSignatureProps = {
    ...defaultProps,
    onChange: patientSignatureCanvasChange,
    ref: canvasRef,
    className: classNames('canvasSignature'),
    brushColor,
    catenaryColor: brushColor
  };

  // signature  end************************************************

  const handleSubmit = (e) => {
    e.preventDefault();
    setMouseDisable('none');
    setBtnSubmit(true);
    let fromValidationAllError = {
      patientName: false,
      date: false,
      patientSignature: false,
      doctorInitiating: false
    };
    let isValid = false;
    if (formData.patientName === '') {
      fromValidationAllError.patientName = true;
      isValid = false;
    } else {
      isValid = true;
    }
    if (formData.date === '') {
      fromValidationAllError.date = true;
      isValid = false;
    } else {
      isValid = true;
    }
    if (patientSignature === '') {
      fromValidationAllError.patientSignature = true;
      isValid = false;
    } else {
      isValid = true;
    }
    if (formData.doctorName === '') {
      fromValidationAllError.doctorInitiating = true;
      isValid = false;
    } else {
      isValid = true;
    }
    setValidationError(fromValidationAllError);
    const data = Object.values(fromValidationAllError).every((item) => item === false);
    if (data) {
      const newValues = {
        appointmentId: appointmentId?.aid,
        patientName: formData.patientName,
        date: moment(new Date()).format(),
        patientSignature: patientSignature,
        doctorInitiating: formData.doctorInitiating
      };
      LdcApi({
        method: 'POST',
        url: 'HealthQuestionnaire/AddMethotrexateForm',
        data: newValues
      })
        .then((res) => {
          if (res?.data?.status?.isSuccess === true) {
            addToast(' Methotrexate form added successfully ', { appearance: 'success' });
            navigate('/thankyou');
            setMouseDisable('auto');
            setBtnSubmit(false);
            sigPatientCanvas.current.clear();
            //  setFromData({
            //     doctorInitiating: location?.state?.[0]?.doctorName,
            //     patientName: location?.state?.[0]?.patientName,
            //     date: moment(new Date()).format('DD/MM/YYYY')
            //   });
          }
        })
        .catch((err) => {
          setMouseDisable('auto');
          setBtnSubmit(false);
        });
    } else {
      setBtnSubmit(false);
      setMouseDisable('auto');
    }
  };

  return (
    <div>
      <div className="navbar_header_container br_c">
        <ConsentFormsNavbar />
      </div>
      {/* <ProfileBar /> */}
      <Container style={{ pointerEvents: { mouseDisable } }}>
        {/* <div className="d-flex my-4 justify-content-end">
          <Button onClick={() => hideForms()} variant="outline-primary mb-3">
            Go to diary
          </Button>
        </div> */}
        <Card>
          <p className="text-center form_heading  mb-5 mt-4">METHOTREXATE SCHEDULE</p>
          <p className="p-4">
            I understand that oral Methorexate is a medication that needs careful monitoring for safety purposes. I have had the risks,
            benefits and potential side effects linked to oral Methotrexate explained to me, before I consented to treatment. I have also
            been given the opportunity to ask any questions prior to starting treatment. I agree to adhere to any schedule of care my clinic
            doctors advise is in my best interest. I have had the typical schedule of care below given to me. I will contact the clinic if I
            have a problem. Clinic doctors reserve the right to stop prescribing oral Methotrexate for me at any stage in the course, if I
            am unable to adhere to any recommendations to my schedule of care.
          </p>
          <div className="p-1">
            <Form onSubmit={(e) => handleSubmit(e)} className="p-4">
              <Form.Group>
                <Row className="p-4">
                  <b>
                    Patient name : <span className="text-danger mr-2">*</span>
                  </b>

                  <div>
                    <input
                      className={`from_control  ${validationError.patientName === true ? 'from_control_invalid' : ''} `}
                      type="text"
                      name="name"
                      disabled
                      // placeholder="name"
                      onChange={(e) => {
                        handelOnchangeValue(e);
                        if (e.target.value.length > 0) {
                          setValidationError({ ...validationError, patientName: false });
                        } else {
                          setValidationError({ ...validationError, patientName: true });
                        }
                      }}
                      value={formData.patientName}
                    />
                    <br />
                    <span className="text-danger">{validationError.patientName === true && 'Field is required.'}</span>
                  </div>
                </Row>
                <Row>
                  <b className="p-4">
                    Date: <span className="text-danger">*</span>
                  </b>

                  <div>
                    <input
                      className={`from_control  ${validationError.date === true ? 'from_control_invalid' : ''} `}
                      type="text"
                      name="doctorDate"
                      disabled
                      // placeholder="name"

                      onChange={(e) => {
                        handelOnchangeValue(e);
                        if (e.target.value.length > 0) {
                          setValidationError({ ...validationError, date: false });
                        } else {
                          setValidationError({ ...validationError, date: true });
                        }
                      }}
                      value={formData.date}
                    />
                    <br />
                    <span className="text-danger">{validationError.date === true && 'Field is required.'}</span>
                  </div>
                </Row>
                <Row className="mx-2">
                  <b className="">
                    Signature : <span className="text-danger">*</span>
                  </b>

                  <Col sm={10} className="">
                    <div className="mt-4">
                      <div style={{ overflow: 'hidden' }}>
                        <CanvasDraw {...patientSignatureProps} />
                        {/* <span className="text-danger">{validationError.childSignature === true && 'Field is required.'}</span> */}
                        <br />
                        <Button
                          classNames="mt-2"
                          onClick={() => {
                            canvasRef.current.clear();
                            setPatientSignature('');
                          }}
                        >
                          Clear
                        </Button>
                      </div>
                      <span className="text-danger">{validationError.signature === true && 'Field is required.'}</span>
                    </div>
                  </Col>
                </Row>
                <Row className="mt-4">
                  <b className="p-3">
                    Doctor initiating: <span className="text-danger">*</span>
                  </b>

                  <Col>
                    <div>
                      <input
                        className={`from_control  ${validationError.doctorInitiating === true ? 'from_control_invalid' : ''} `}
                        type="text"
                        name="doctorInitiating"
                        disabled
                        // placeholder="name"

                        onChange={(e) => {
                          handelOnchangeValue(e);
                          if (e.target.value.length > 0) {
                            setValidationError({ ...validationError, doctorInitiating: false });
                          } else {
                            setValidationError({ ...validationError, doctorInitiating: true });
                          }
                        }}
                        value={formData.doctorInitiating}
                      />
                      <br />
                      <span className="text-danger">{validationError.doctorInitiating === true && 'Field is required.'}</span>
                    </div>
                  </Col>
                </Row>
              </Form.Group>
              <Row className="p-2">
                <p style={{ fontWeight: 'bold' }} className="mt-5">
                  Typical schedule care (can vary):{' '}
                </p>
              </Row>
              <Row className="p-2">
                <p style={{ textDecoration: 'underline', fontWeight: 'bold' }}>Before starting treatment:</p>
              </Row>
              <Row>
                <p className="p-1 ml-4">1. Initial baseline blood tests: FBC, U&Es, LFTs, Type III procollagen (PIIINP).</p> <br />
              </Row>
              <Row>
                <p className="p-1 ml-4">2. Chest X-ray.</p>
              </Row>
              <Row>
                <p className="p-2">
                  <span style={{ textDecoration: 'underline', fontWeight: 'bold' }}>After starting treatment:</span> the following blood
                  tests are needed every 2 weeks until on a stable dose for 6 weeks, then once on stable dose, to be monitored monthly for 3
                  months, thereafter every 12 weeks;
                </p>
                <p className="p-4">
                  1. FBC (full blood count),
                  <br />
                  2. U&Es (urea and electrolytes including serum creatinine and eGFR)
                  <br />
                  3. LFTs (including ALT or AST and albumin)
                </p>
                <p className="p-2">
                  Initial bloods cost £250*. Each subsequent monitoring blood test costs £90* unless PIIINP is repeated in which case an
                  additional fee of £160 is payable. The above schedule frequency may change if abnormal results are found or after a
                  treatment dose change.
                </p>
                <p className="p-2" style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
                  Follow-up Consultations
                </p>
                <p className="p-2">
                  A review will be required by booking a follow-up consultation every 6 to 8 weeks and once the dose of the medication and
                  your skin condition is stable then it will be reduced to once every 4 months.
                </p>
                <p className="p-2">Each follow-up consultation costs £175*.</p> <br />
              </Row>
              <Row>
                <p style={{ fontStyle: 'italic' }} className="p-2">
                  (Side Effects section on next page)
                </p>
              </Row>
              <Row>
                <p className="p-2" style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
                  Side Effects
                </p>
              </Row>
              <Row>
                <p className="p-2">The following is a list of some common side effects which can be expected.</p>
                <ul>
                  <li>Tiredness</li>
                  <li>Headaches</li>
                  <li>Hair loss</li>
                  <li>Diarrhoea</li>
                  <li>Other common side effects are loss of appetite, nausea, vomitings, stomach upset, and indigestion</li>
                </ul>
              </Row>
              <Row>
                <p className="p-2" style={{ fontStyle: 'italic' }}>
                  Serious side effects, albeit rare, are a reason to seek prompt medical review and include:
                </p>
                <ul>
                  <li>Jaundice - yellowing of the eyes and skin which can indicate a problem with the liver</li>
                  <li>Respiratory symptoms - feeling breathless or experiencing a persistent cough</li>
                  <li>Swelling of hands and feet or change in urinary frequency</li>
                  <li>Severe sore throat, easy bleeding or abnormal bruising - urgent blood test required</li>
                  <li>Persistent fever - signs of an infection or complication of methotrexate treatment</li>
                  <li>
                    Severe skin rash or blisters on your skin, mouth, eyes or genitals – these may be signs of Stevens-Johnson syndrome
                  </li>
                </ul>
              </Row>
              <Row>
                <p className="p-2" style={{ fontWeight: 'bold' }}>
                  N.B.{' '}
                </p>
                <ul>
                  <li>Blood tests are needed as oral Methotrexate can adversely affect your kidney and liver.</li>
                  <li>
                    Consultations are an opportunity for your doctors to review your care and monitor your treatment safely. Reviews tend to
                    include your skin, any side effects you may be experiencing, answer questions you have and dosage changes.
                  </li>
                  <li>Consultations can be conducted online over a video call or a face to face clinic attendance. </li>
                  <li>
                    If you decide to have your blood tests done externally please be aware you will have to be responsible in organising and
                    getting the correct test results to us in a timely manner to avoid delays or disruptions.
                  </li>
                </ul>
              </Row>
              <p style={{ fontStyle: 'italic' }}>*Price correct at the time of publication but subject to change without notice.</p>
              <div className="d-flex my-4    ">
                <button type="submit" disabled={btnSubmit} className="btn px-4 btn-outline-primary">
                  {btnSubmit ? 'Loading....' : 'Submit'}
                </button>
                {/* <CustomButtons type="submit " buttonDisabled={btnSubmit} variant="primary" className="outline- px-4" name="Save" /> */}
              </div>
            </Form>
          </div>
        </Card>
      </Container>
    </div>
  );
};

export default MethotrexateMessage;
